import { render, staticRenderFns } from "./DadosRecursosAnimais.vue?vue&type=template&id=72753207&scoped=true&"
import script from "./DadosRecursosAnimais.vue?vue&type=script&lang=js&"
export * from "./DadosRecursosAnimais.vue?vue&type=script&lang=js&"
import style0 from "./DadosRecursosAnimais.vue?vue&type=style&index=0&id=72753207&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72753207",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VFlex,VForm,VLayout,VTextField})
